import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * This interface describes the options that can be passed to a
 * dialog.
 */
export interface InputDialogOptions {
  title?: string;
  text?: string;
  strong?: string;
  extra?: string;
  inputType?: string;
  inputLabel?: string;
  inputValue?: string;
  inputValidator?: (value: string) => true|string;
  buttonLabel?: string;
  buttonClass?: string;
  dialogClass?: string;
}

/**
 * This interface represents the result of an input dialog.
 */
export interface InputDialogResult {
  errorMessage: string;
  inputValue: string;
  submit: boolean;
}

/**
 * This component displays a modal with an input box.
 */
@Component({
  selector: 'lib-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
})
export class InputDialogComponent {

  public options: InputDialogOptions;
  public inputValue = '';

  constructor(
    private dialogRef: MatDialogRef<InputDialogComponent, InputDialogResult>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.options = data || {};

    if (this.options.inputValue) {
      this.inputValue = this.options.inputValue;
    }
  }

  /**
   * Open the dialog.
   */
  public static open(
    dialogService: MatDialog,
    data: InputDialogOptions,
    config: MatDialogConfig = {},
  ): MatDialogRef<InputDialogComponent, InputDialogResult> {
    const options = { ...config };
    options.data = data;

    return dialogService.open<
      InputDialogComponent,
      InputDialogOptions,
      InputDialogResult
    >(InputDialogComponent, options);
  }

  /**
   * Whether the input is valid or not.
   */
  public get errorMessage(): string {
    if (!this.options.inputValidator || !this.options.inputType) {
      return '';
    }

    const result = this.options.inputValidator(this.inputValue);
    return result === true ? null : result;
  }

  /**
   * Clear all the selected filters.
   */
  public close(submit = false): false {
    if (this.errorMessage && submit) {
      return false;
    }

    this.dialogRef.close({
      errorMessage: this.errorMessage,
      inputValue: this.inputValue,
      submit,
    });

    return false;
  }

}
